import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { Col, Modal, Row } from "react-bootstrap";
import { BrowserView, MobileView } from "react-device-detect";
import { FaEthereum, FaTimes, FaPlus } from "react-icons/fa";
import OptionListTile from "./OptionListTile";
import IconButton from "./IconButton";
import { Center } from "./Center";
import { SizedBox } from "./SizedBox";
import { TitleText } from "./TitleText";
import { SubtitleText } from "./SubtitleText";

// Shown when a Solana wallet signs in but has no account yet. The user can
// start fresh or connect this wallet to an existing account via Ethereum.
export default function AccountChoiceModal({
  open,
  setOpen,
  onCreateNew,
  onConnectExisting,
}) {
  const body = (
    <div style={{ width: "90%" }}>
      <SizedBox height={8} />
      <TitleText textAlign={"start"}>New Solana wallet</TitleText>
      <SizedBox height={8} />
      <SubtitleText textAlign={"start"} fontSize={"14px"}>
        This wallet isn't linked to an account yet.
      </SubtitleText>
      <SizedBox height={20} />
      <OptionListTile
        onClick={onCreateNew}
        name={"Create a new profile"}
        Icon={FaPlus}
      />
      <hr />
      <OptionListTile
        onClick={onConnectExisting}
        name={"Connect to my Ethereum account"}
        Icon={FaEthereum}
      />
      <SizedBox height={20} />
    </div>
  );

  return (
    <>
      <BrowserView>
        <Modal
          dialogClassName="modal-60w"
          show={open}
          onHide={() => setOpen(false)}
        >
          <Modal.Body>
            <Center>
              <div style={{ width: "90%" }}>
                <SizedBox height={8} />
                <Row className="d-flex align-items-end justify-content-end">
                  <Col className="d-flex align-items-end justify-content-end">
                    <IconButton Icon={FaTimes} onClick={() => setOpen(false)} />
                  </Col>
                </Row>
                {body}
              </div>
            </Center>
          </Modal.Body>
        </Modal>
      </BrowserView>
      <MobileView>
        <BottomSheet open={open} onDismiss={() => setOpen(false)}>
          <Center>{body}</Center>
          <SizedBox height={32} />
        </BottomSheet>
      </MobileView>
    </>
  );
}
